const ZONA_ARGENTINA = 'America/Argentina/Buenos_Aires';

// «02/11» en hora argentina: un vencimiento a medianoche UTC no debe mostrarse un día antes.
export const fechaCorta = (fecha) => {
  const d = new Date(fecha);
  if (!fecha || Number.isNaN(d.getTime())) return '';
  const partes = Object.fromEntries(
    new Intl.DateTimeFormat('en-US', { timeZone: ZONA_ARGENTINA, day: '2-digit', month: '2-digit' }).formatToParts(d).map((p) => [p.type, p.value]),
  );
  return `${partes.day}/${partes.month}`;
};

const diaArgentino = (d) => new Intl.DateTimeFormat('en-CA', { timeZone: ZONA_ARGENTINA }).format(d);

// Días corridos desde una fecha sin hora (medianoche UTC) hasta hoy en hora argentina; null si la fecha no sirve.
export const diasDesde = (valor, ahora = new Date()) => {
  const d = new Date(valor);
  if (!valor || Number.isNaN(d.getTime())) return null;
  const dia = (s) => Date.parse(`${s}T00:00:00Z`);
  const dias = Math.round((dia(diaArgentino(ahora)) - dia(d.toISOString().slice(0, 10))) / 86400000);
  return Math.max(0, dias);
};

// «02 nov» en UTC: las fechas sin hora se guardan a medianoche UTC y en hora argentina caerían un día antes.
export const fechaCortaUtc = (valor) => {
  const d = new Date(valor);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString('es-AR', { timeZone: 'UTC', day: '2-digit', month: 'short' });
};
